import React, { useState } from "react"
import Button from "../UI/Button/Button"
import PropTypes from "prop-types"
import ReCAPTCHA from "react-google-recaptcha"
import {
  validate,
  validateEmail,
  validateLength,
  validateZipCode,
} from "../../helpers/FormValidations"
import * as styles from "./Form-tw-styles"
import Typography from "../UI/Typography/Typography"
import RenderField from "../../helpers/RenderField"
import ModalWrapper from "../Wrappers/ModalWrapper/ModalWrapper"
import axios from "axios"
import { validString } from "../../helpers/FormValidations"
import {
  API_ERROR_MSG,
  API_SUCCESS_MSG,
  formRequestPayload,
} from "../../constants/label.constants"
import variants from "../../constants/variants.constants"
import { formSubmitObj, gaEventClick } from "../../constants/gtm.constants"
import LoaderIcon from "../../assests/icons/LoaderIcon"

let minLenFields = ["firstName", "lastName"]
let checkboxList = ["confirmationCheckbox", "aggrementCheckbox"]
let mandateFields = {
  firstName: "",
  lastName: "",
  address1: "",
  city: "",
  state: "",
  zip: "",
  telephone: "",
  email: "",
  mediaOutlet: "",
}
let orderedFieldList = {
  firstName: "",
  lastName: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  telephone: "",
  email: "",
  mediaOutlet: "",
  comments: "",
}

let orderedcheckboxList = {
  confirmationCheckbox: "",
  aggrementCheckbox: "",
}

const orderList = (list, actualList) => {
  Object.entries(list).map(([key]) => {
    if (actualList[key]) {
      list[key] = actualList[key]
      return list[key]
    }
  })
}
const Form = props => {
  const { heading, jsonEditor, description } = props
  const formUrl = process.env.GATSBY_FORM_API
  const { fieldList, checkbox, submit, bookType, reCaptchaError, variant } =
    jsonEditor
  const siteKey =
    variant === variants?.formInputStyle_6_6
      ? process.env.GATSBY_APP_INVESTORS_SITE_KEY
      : process.env.GATSBY_APP_SITE_KEY

  orderList(orderedFieldList, fieldList)
  //orderList(orderedcheckboxList, checkbox)

  const [form, setForm] = useState(orderedFieldList)
  const [isAPIFailed, setIsAPIFailed] = useState(false)
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [checkBox, setCheckBox] = useState(orderedcheckboxList)
  const [isLoading, setIsLoading] = useState(false)
  const [recaptchaValue, setRecaptchaValue] = useState("")
  const [recaptchaDone, setRecaptchaDone] = useState(false)
  const [ShowRecaptchaError, setShowRecaptchaError] = useState(false)
  const [showError, setShowError] = useState(false)
  const [isSubmitClicked, setIsSubmitClicked] = useState(false)
  const style = styles[variant] || styles["defaultStyle"]
  const { formTitle, formDesc, formTitleWrap } = style

  function ValidateForm(orgObj, tempObj) {
    return Object.entries(orgObj).map(([key, value]) => {
      tempObj[key] = validate(value)
      setForm(field => ({
        ...field,
        [key]: {
          ...field[key],
          isValid: tempObj[key].isValid,
        },
      }))
      return tempObj[key].isValid
    })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (isFormSubmitted) {
      setIsFormSubmitted(false)
    }

    if (!recaptchaDone) {
      setShowRecaptchaError(true)
    } else {
      setShowRecaptchaError(false)
      let hasOtherInput = true
      setIsSubmitClicked(true)
      const validateField = form

      const isfieldsValid = ValidateForm(form, validateField)

      if (!isfieldsValid.includes(false) && hasOtherInput && recaptchaDone) {
        setIsLoading(true)

        let requestBodyObj
        if (variant === variants?.formInputStyle_6_6) {
          requestBodyObj = {
            firstName: form?.firstName?.value,
            lastName: form?.lastName?.value,
            address1: form?.address1?.value,
            address2: form?.address2?.value,
            city: form?.city?.value,
            state: form?.state?.value,
            zipCode: form?.zip?.value,
            telephone: form?.telephone?.value,
            email: form?.email?.value,
            comments: form?.comments?.value,
            enquiryType: formRequestPayload?.enquiryConsumerType,
          }
        } else {
          requestBodyObj = {
            firstName: form?.firstName?.value,
            lastName: form?.lastName?.value,
            telephone: form?.telephone?.value,
            email: form?.email?.value,
            mediaOutlet: form?.mediaOutlet?.value,
            comments: form?.comments?.value,
            enquiryType: formRequestPayload?.enquiryBusinessType,
          }
        }
        const payload = {
          requestDomain: formRequestPayload?.requestDomain,
          requestCountry: formRequestPayload?.requestCountry,
          requestLanguage: formRequestPayload?.requestLanguage,
          requestCampaign:
            variant === variants?.formInputStyle_6_6
              ? formRequestPayload?.requestInvestorCampaign
              : formRequestPayload?.requestCampaign,
          "g-recaptcha-response": recaptchaValue,
          requestBody: requestBodyObj,
        }

        try {
          const res = await axios.post(formUrl, payload)

          if (res.status === 200) {
            setIsFormSubmitted(true)
            setIsAPIFailed(false)
            setShowError(false)
            setIsLoading(false)
            setShowRecaptchaError(false)
            // success: add custom object to window datalyer obj when form is submitted
            formSubmitObj.GAeventAction = {
              ...requestBodyObj,
              submit: "success",
            }
            if (location && location.href) {
              formSubmitObj.GAeventLabel = location.href
            }
            if (window !== "undefined" && window.dataLayer) {
              return window.dataLayer.push({ ...formSubmitObj })
            }
          }
        } catch (error) {
          setIsLoading(false)
          setShowError(false)
          setIsAPIFailed(true)
          setShowRecaptchaError(false)
          // failure: add custom object to window datalyer obj when form is submitted
          formSubmitObj.GAeventAction = { ...requestBodyObj, submit: "failure" }
          if (location && location.href) {
            formSubmitObj.GAeventLabel = location.href
          }
          if (window !== "undefined" && window.dataLayer) {
            return window.dataLayer.push({ ...formSubmitObj })
          }

          throw new Error(error)
        }
      } else {
        const element = document.getElementById("form")
        element.scrollIntoView({ behavior: "smooth" })
        setIsLoading(false)
        setShowError(true)
        setIsAPIFailed(false)
        if (!isfieldsValid.includes(false) && hasOtherInput && !recaptchaDone) {
          setShowRecaptchaError(true)
        }
      }
    }
  }

  function handleOtherFields(event, id) {
    setForm(field => ({
      ...field,
      [id]: {
        ...field[id],
        value: event.target.value,
      },
    }))
  }

  const handleChange = (event, id) => {
    handleOtherFields(event, id)

    Object.entries(mandateFields)?.map(([key, value]) => {
      if (key == id && id !== "confirmationCheckbox") {
        if (minLenFields.includes(id)) {
          mandateFields[id] = event.target.value.length >= 2 ? true : false
        } else if (id == "email") {
          mandateFields[id] = validateEmail(event.target.value) ? true : false
        } else if (id == "telephone") {
          mandateFields[id] = validateLength(event.target.value) ? true : false
        } else if (id == "zip") {
          mandateFields[id] = validateZipCode(event.target.value) ? true : false
        } else {
          mandateFields[id] = event.target.value !== "" ? true : false
        }
      }
      if (id == "confirmationCheckbox") {
        mandateFields[id] = event.target.checked
      }
    })
  }

  const handleOnBlur = (event, id) => {
    if (minLenFields.includes(id)) {
      if (event.target.value == "") {
        isSubmitClicked ? setShowError(true) : setShowError(false)
        setForm(field => ({
          ...field,
          [id]: { ...field[id], isValid: true },
        }))
      } else {
        const isError =
          event.target.value.length < 2 || !validString(event.target.value)
            ? true
            : false
        isSubmitClicked && showError
          ? setShowError(true)
          : setShowError(isError)
        setForm(field => ({
          ...field,
          [id]: { ...field[id], isValid: !isError },
        }))
      }
    }
    if (id === "email") {
      const validateEmail = validate({ ...form[id], value: event.target.value })
      const check = !validateEmail.isValid ? true : false
      showError ? setShowError(true) : setShowError(check)
      if (event.target.value == "") {
        isSubmitClicked ? setShowError(true) : setShowError(false)
      }
    }
  }

  function onChange(value) {
    setRecaptchaValue(value)
    value ? setRecaptchaDone(true) : setRecaptchaDone(false)
  }

  function handleOnFocus(id) {}

  function renderFields(list) {
    return Object.entries(list).map(([key, value]) => (
      <RenderField
        key={key}
        id={key}
        field={value}
        onBlur={handleOnBlur}
        handleChange={handleChange}
        onFocus={handleOnFocus}
        variant={variant}
        error=""
      />
    ))
  }
  return (
    <form id="form" className=" formStyle mb-[50px]" autoComplete="on">
      <div className={formTitleWrap}>
        <div className={formTitle}>
          {heading && <Typography content={heading}></Typography>}
        </div>
        <div className={formDesc}>
          {description && <Typography content={description}></Typography>}
        </div>
      </div>
      {isFormSubmitted && (
        <div className="md:max-w-md lg:max-w-lg xl:max-w-xl px-[35px] md:px-[15px] mx-auto">
          <div className="bg-[#287819] text-white  tracking-[0.53px] flex align-center  leading-[42px] font-Bold mb-[20px] min-h-[46px] px-10  text-left w-full text-[28px]">
            {API_SUCCESS_MSG}
          </div>
        </div>
      )}
      {isAPIFailed && (
        <div className="bg-white text-lg leading-7 my-11 mx-auto p-30 text-center w-[469px] max-w-[90%] text-pureRed">
          {API_ERROR_MSG}
        </div>
      )}
      {isLoading && (
        <div className="loader">
          {" "}
          <ModalWrapper>
            <LoaderIcon />
          </ModalWrapper>
        </div>
      )}
      <div className={style.formWrap}>{renderFields(form)}</div>
      <div className=" my-[40px] md:max-w-md lg:max-w-lg xl:max-w-xl px-[35px] md:px-[15px] max-w-full phillySubmit mx-auto flex justify-center md:block">
        <div className="lg:w-[454px]">{renderFields(checkBox)}</div>
        <div className="md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto my-0 child:flex child:justify-left lg:child:justify-start captacha">
          <ReCAPTCHA sitekey={siteKey} onChange={e => onChange(e)} />

          {ShowRecaptchaError && (
            <p role="text" aria-label={reCaptchaError} className="text-pureRed">{reCaptchaError}</p>
          )}
        </div>
      </div>
      <Button
        text={submit.label}
        onClick={handleSubmit}
        className={style?.btnStyle}
        gaEventClass={gaEventClick}
        dataActionDetail={"submit"}
        ariaLabel="Submit Form"
      />
    </form>
  )
}

Form.propTypes = {
  description: PropTypes.string,
  heading: PropTypes.string,
  jsonEditor: PropTypes.any,
}

export default Form
